import { CardElement, ElementsConsumer } from "@stripe/react-stripe-js";

import americanExpressLogo from "../../../assets/images/logo/american_express.png";
import jcbLogo from "../../../assets/images/logo/jcb.png";
import mastercardLogo from "../../../assets/images/logo/mastercard.png";
import logo from "../../../assets/images/logo/Trellis_Logomark_color.png";
import visaLogo from "../../../assets/images/logo/visa.png";
import axios from "axios";
import { Button } from "../../../components/core/basic/Button";
import Card from "../../../components/core/basic/Card";
import ModalAlert from "../../../components/core/basic/ModalAlert";
import CustomHref from "../../../components/core/blocks/CustomHref";
import React from "react";
import { withTranslation } from "react-i18next";
import { Switch } from "../../../components/fields/base/Switch";
import { TextField } from "../../../components/fields/base/TextField";
import { store } from "../../../redux/store";
import { getURLPrefix } from "../../../utils/getUrlPrefix";
import { css } from "../../../../styled-system/css";
import { Grid, HStack, VStack } from "../../../../styled-system/jsx";

const URL_PREFIX = getURLPrefix();

const options = {
  hidePostalCode: true,
  style: {
    base: {
      color: "#D91266",
      letterSpacing: "1px",
      fontSize: "15px",
      fontWeight: 500,
      fontFamily: "sans-serif",
      "::placeholder": {
        color: "#c3c3c3",
      },
    },
    complete: { color: "#850066" },
    invalid: {
      color: "#ff0033",
    },
  },
};

const brandLogos = {
  mastercard: mastercardLogo,
  visa: visaLogo,
  amex: americanExpressLogo,
  jcb: jcbLogo,
};

class CardForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      customerId: this.props.customerId,
      paymentMethodList: [],
      selectedCard: "",
      addCard: false,
      error: {},
      nameOnCard: "",
      activeCard: "",
      billingAddress: {},
      invalidNameOnCard: false,
      cardError: false,
      cardComplete: false,
      addCardActive: false,
    };
  }

  componentDidMount() {
    if (this.props.customerId !== "") {
      this.getUserPaymentMethods();
      this.getActiveCard();
    }
  }

  componentDidUpdate() {
    if (this.state.customerId !== this.props.customerId) {
      // oxlint-disable-next-line react/no-did-update-set-state
      this.setState({ customerId: this.props.customerId }, () => {
        this.getUserPaymentMethods();
        this.getActiveCard();
      });
    }
  }

  getActiveCard() {
    const AuthStr = "Bearer ".concat(store.getState().auth.tokens.access_token);
    axios
      .get(URL_PREFIX + "/api/billing/customer", {
        params: {},
        headers: { Authorization: AuthStr },
      })
      .then((res) => {
        if (res.data.default_payment_method !== undefined) {
          this.setState({
            activeCard: res.data.default_payment_method,
            billingAddress: res.data.billing_address,
          });
        }
      });
  }

  getUserPaymentMethods() {
    const AuthHeader = "Bearer ".concat(store.getState().auth.tokens.access_token);
    axios
      .get(URL_PREFIX + "/api/billing/paymentmethod?customerId=" + this.state.customerId, {
        params: {},
        headers: { Authorization: AuthHeader },
      })
      .then((res) => {
        if (this.state.selectedCard === "") {
          this.setState({
            paymentMethodList: res.data.cards.data,
            selectedCard: res.data.cards.data[0],
          });
        } else {
          let selCard = {};
          for (let i = 0; i < res.data.cards.data.length; i++) {
            if (this.state.selectedCard.id === res.data.cards.data[i].id) {
              selCard = res.data.cards.data[i];
              break;
            }
          }
          this.setState({
            paymentMethodList: res.data.cards.data,
            selectedCard: selCard,
          });
        }
      });
  }

  updateDefaultPaymentMethod(paymentMethodId) {
    if (store.getState().amz_onboard.org_status === "payment_required") {
      this.retryInvoiceWithNewPaymentMethod({
        customerId: this.state.customerId,
        paymentMethodId: paymentMethodId,
        auth: store.getState().auth.tokens.access_token,
      });
    } else {
      const AuthHeader = "Bearer ".concat(store.getState().auth.tokens.access_token);
      const data = {
        customerId: this.state.customerId,
        paymentMethodId: paymentMethodId,
      };
      axios
        .put(URL_PREFIX + "/api/billing/paymentmethod", data, {
          params: {},
          headers: { Authorization: AuthHeader },
        })
        .then(() => {
          this.setState(
            {
              activeCard: paymentMethodId,
            },
            () => {
              this.getUserPaymentMethods();
              this.getActiveCard();
            },
          );
        })
        .catch(() => {
          const { t } = this.props;
          this.setState({
            error: {
              title: t(($) => $.admin["Please try again"]),
              message: t(($) => $.admin["Failed to update your preferences."]),
            },
          });
        });
    }
  }

  retryInvoiceWithNewPaymentMethod({ customerId, paymentMethodId }) {
    const paymentInfo = {
      customerId: customerId,
      paymentMethodId: paymentMethodId,
    };

    const AuthHeader = "Bearer ".concat(store.getState().auth.tokens.access_token);

    return axios
      .post(URL_PREFIX + "/api/billing/retrysubscription", paymentInfo, {
        params: {},
        headers: { Authorization: AuthHeader },
      })
      .then((result) => {
        const { t } = this.props;
        if (result.error) {
          this.setState({
            error: {
              title: t(($) => $.admin["Improper Card Info"]),
              message: t(($) => $.admin["Your card was declined, please try a new card."]),
            },
          });
          throw result;
        }
        return result;
      })
      .then((result) => {
        if (result.data.subscription.status === "active" || result.data.subscription.status === "trialing") {
          return {
            paymentMethodId: paymentMethodId,
            subscription: result,
          };
        }
      })
      .then(this.handleRequiresPaymentMethod)
      .catch(() => {
        const { t } = this.props;
        this.setState({
          error: {
            title: t(($) => $.admin["Improper Card Info"]),
            message: t(($) => $.admin["Your card was declined, please use a different card to pay."]),
          },
        });
      });
  }

  handleRequiresPaymentMethod = ({ subscription }) => {
    const { t } = this.props;
    const tempSubscription = subscription.data.subscription;
    if (
      tempSubscription.status !== "trialing" &&
      tempSubscription.status !== "active" &&
      tempSubscription.latest_invoice.payment_intent !== null &&
      tempSubscription.latest_invoice.payment_intent.status !== null
    ) {
      if (tempSubscription.latest_invoice.payment_intent.status === "requires_payment_method") {
        this.setState({
          error: {
            title: t(($) => $.admin["Payment Failed"]),
            message: t(($) => $.admin["Please use a different card for the payment."]),
          },
        });
      }
    }
    window.location.reload();
  };

  addNewCard = async () => {
    this.setState({ addCardActive: true });
    const { stripe, elements, t } = this.props;

    if (!stripe || !elements) {
      this.setState({
        error: {
          title: t(($) => $.admin["Something's not right"]),
          message: t(($) => $.admin["Please retry after reloading/refreshing the page."]),
        },
        addCardActive: false,
      });
      return;
    }
    this.createPaymentMethod(
      elements.getElement(CardElement),
      this.state.customerId,
      store.getState().auth.tokens.access_token,
      "update",
    );
  };

  createPaymentMethod(cardElement, customerId, auth, action) {
    const { stripe, t } = this.props;

    const billing_details = {
      address: {
        country: this.state.billingAddress.country,
        postal_code: this.state.billingAddress.postal_code,
        state: this.state.billingAddress.state,
      },
      name: this.state.nameOnCard,
    };

    return stripe
      .createPaymentMethod({
        type: "card",
        card: cardElement,
        billing_details: billing_details,
      })
      .then((result) => {
        if (result.error) {
          this.setState({
            error: {
              title: t(($) => $.admin["Improper Card Info"]),
              message: result.error.message,
            },
            addCardActive: false,
          });
        } else if (action === "update") {
          this.updateSubscription({
            customerId: customerId,
            paymentMethodId: result.paymentMethod.id,
            auth: store.getState().auth.tokens.access_token,
          });
        } else {
          this.setState({ addCardActive: false });
        }
      });
  }

  updateSubscription({ customerId, paymentMethodId }) {
    const paymentInfo = {
      customerId: customerId,
      paymentMethodId: paymentMethodId,
    };
    const AuthHeader = "Bearer ".concat(store.getState().auth.tokens.access_token);
    return axios
      .post(URL_PREFIX + "/api/billing/paymentmethod", paymentInfo, {
        params: {},
        headers: { Authorization: AuthHeader },
      })
      .then((result) => {
        const { t } = this.props;
        if (result.error) {
          this.setState({
            error: {
              title: t(($) => $.admin["Card Error"]),
              message: t(($) => $.admin["Please try again or try using a different card."]),
            },
            addCardActive: false,
          });
          throw result;
        }
        return result;
      })
      .then(() => {
        this.setState({ addCardActive: false });
        this.setState({ addCard: false }, () => {
          this.getUserPaymentMethods();
          this.getActiveCard();
        });
        return {
          paymentMethodId: paymentMethodId,
        };
      })
      .catch(() => {
        const { t } = this.props;
        this.setState({
          error: {
            title: t(($) => $.admin["Card Error"]),
            message: t(($) => $.admin["Please try again or try using a different card."]),
          },
          addCardActive: false,
        });
      });
  }

  render() {
    const { stripe, t } = this.props;
    return (
      <div>
        <Card className={css({ paddingX: "large" })}>
          <VStack gap="medium" alignItems="stretch">
            <p className={css({ textAlign: "center", fontSize: "20px", fontWeight: 600 })}>
              {t(($) => $.admin["Payment Information"])}
            </p>

            {this.state.addCard ?
              /* ── Add card view ── */
              <VStack
                gap="large"
                alignItems="stretch"
                className={css({ maxWidth: "500px", mx: "auto", width: "100%", py: "medium" })}
              >
                <TextField
                  variant="inline"
                  label={t(($) => $.admin["Name on Card"])}
                  placeholder={t(($) => $.admin["Name on Card"])}
                  value={this.state.nameOnCard}
                  onChange={(value) => {
                    const NameOnCardRex = /^[a-zA-Z_]+( [a-zA-Z_]+)*$/;
                    NameOnCardRex.test(value) === false ?
                      this.setState({ nameOnCard: value, invalidNameOnCard: true })
                    : this.setState({ nameOnCard: value, invalidNameOnCard: false });
                  }}
                  errorMessage={
                    this.state.nameOnCard !== "" && this.state.invalidNameOnCard ?
                      t(($) => $.admin["Invalid name"])
                    : undefined
                  }
                />

                <VStack gap="xsmall" alignItems="stretch">
                  <span className={css({ fontSize: "14px", fontWeight: 500 })}>
                    {t(($) => $.admin["Card Details"])}
                  </span>
                  <HStack gap="small" alignItems="center">
                    <div className={css({ flex: 1 })}>
                      <CardElement
                        options={options}
                        onChange={(event) => {
                          this.setState({
                            cardComplete: !!event.complete,
                            cardError: !!event.error,
                          });
                        }}
                      />
                    </div>
                    {this.state.cardError && <i className={`fa fa-times ${css({ color: "error" })}`} />}
                  </HStack>
                </VStack>

                {!this.state.addCardActive ?
                  <Button
                    disabled={
                      !stripe ||
                      this.state.nameOnCard === "" ||
                      this.state.invalidNameOnCard ||
                      !this.state.cardComplete
                    }
                    onPress={() => this.addNewCard()}
                  >
                    {t(($) => $.admin["Add Card"])}
                  </Button>
                : <div className={css({ textAlign: "center" })}>
                    <img
                      src={logo}
                      alt={t(($) => $.common["Loading..."])}
                      className="rotate"
                      width="70"
                      height="auto"
                    />
                  </div>
                }

                {!this.state.addCardActive && (
                  <span
                    className={css({ fontSize: "14px", alignSelf: "center" })}
                    onClick={() => this.setState({ addCard: false })}
                  >
                    <CustomHref textDecoration="none" text={t(($) => $.common.actions.Cancel)} />
                  </span>
                )}
              </VStack>
            : /* ── Card details view ── */
              <Grid
                gridTemplateColumns={{ base: "1fr", sm: "1fr 280px" }}
                gap="large"
                className={css({ py: "medium" })}
              >
                {/* Left: card info */}
                {this.state.selectedCard !== undefined && this.state.selectedCard !== "" && (
                  <VStack gap="small" alignItems="stretch" className={css({ fontSize: "14px" })}>
                    <HStack gap="small">
                      <span className={css({ fontWeight: 500, minWidth: "120px" })}>
                        {t(($) => $.admin["Name on Card:"])}
                      </span>
                      <span>{this.state.selectedCard.billing_details.name}</span>
                    </HStack>
                    <HStack gap="small">
                      <span className={css({ fontWeight: 500, minWidth: "120px" })}>
                        {t(($) => $.admin["Card Number:"])}
                      </span>
                      <span>
                        {t(($) => $.admin["ending in {last4}"], { last4: this.state.selectedCard.card.last4 })}
                      </span>
                    </HStack>
                    <HStack gap="small">
                      <span className={css({ fontWeight: 500, minWidth: "120px" })}>
                        {t(($) => $.admin["Card Type:"])}
                      </span>
                      <span>{this.state.selectedCard.card.brand}</span>
                    </HStack>
                    <HStack gap="small">
                      <span className={css({ fontWeight: 500, minWidth: "120px" })}>
                        {t(($) => $.admin["Expiration Date:"])}
                      </span>
                      <span>
                        {this.state.selectedCard.card.exp_month}/{this.state.selectedCard.card.exp_year}
                      </span>
                    </HStack>

                    <HStack gap="small" alignItems="center" className={css({ marginTop: "small" })}>
                      <span className={css({ fontWeight: 500 })}>{t(($) => $.admin["Active:"])}</span>
                      <Switch
                        isSelected={this.state.selectedCard.id === this.state.activeCard}
                        isDisabled={this.state.selectedCard.id === this.state.activeCard}
                        onChange={() => this.updateDefaultPaymentMethod(this.state.selectedCard.id)}
                      />
                    </HStack>
                    {this.state.selectedCard.id === this.state.activeCard && (
                      <p className={css({ fontSize: "12px", color: "text.secondary" })}>
                        {t(($) => $.admin["This is your default payment card for all future payments."])}
                      </p>
                    )}
                  </VStack>
                )}

                {/* Right: scrollable card list */}
                {this.state.paymentMethodList.length > 0 && (
                  <VStack gap="small" alignItems="stretch">
                    <div
                      className={css({
                        overflowY: "auto",
                        maxHeight: "200px",
                      })}
                    >
                      <VStack gap="xsmall" alignItems="stretch">
                        {this.state.paymentMethodList.map((paymentMethodItem, index) => {
                          const isCardSelected =
                            this.state.selectedCard.id !== undefined &&
                            this.state.selectedCard.id === paymentMethodItem.id;
                          return (
                            <HStack
                              key={"paymentMethod" + (index + 1)}
                              gap="small"
                              alignItems="center"
                              className={css({
                                padding: "small",
                                borderRadius: "sm",
                                cursor: "pointer",
                                backgroundColor: isCardSelected ? "royalPurple" : "white",
                                color: isCardSelected ? "white" : "text.secondary",
                                fontSize: "14px",
                                fontWeight: 500,
                                transition: "background-color 0.15s",
                              })}
                              onClick={() => this.setState({ selectedCard: paymentMethodItem })}
                            >
                              {brandLogos[paymentMethodItem.card.brand] && (
                                <img
                                  src={brandLogos[paymentMethodItem.card.brand]}
                                  alt={t(($) => $.admin["Card brand logo"])}
                                  width="36"
                                  height="22.5"
                                />
                              )}
                              <span>**** **** **** {paymentMethodItem.card.last4}</span>
                              {paymentMethodItem.id === this.state.activeCard && (
                                <span className={css({ marginLeft: "auto", fontSize: "12px" })}>
                                  {t(($) => $.admin["active"])}
                                </span>
                              )}
                            </HStack>
                          );
                        })}
                      </VStack>
                    </div>
                    <span
                      className={css({ fontSize: "14px", textAlign: "center", cursor: "pointer" })}
                      onClick={() => this.setState({ addCard: true })}
                    >
                      <CustomHref text={t(($) => $.admin["Add New Card"])} />
                    </span>
                  </VStack>
                )}
              </Grid>
            }
          </VStack>
        </Card>

        {this.state.error.title !== undefined && (
          <ModalAlert
            title={this.state.error.title}
            onClick={() => this.setState({ error: {} })}
            msg={this.state.error.message}
          />
        )}
      </div>
    );
  }
}

const TranslatedCardForm = withTranslation(["admin", "common"])(CardForm);

const PaymentCards = (props) => {
  return (
    <ElementsConsumer>
      {({ elements, stripe }) => (
        <TranslatedCardForm elements={elements} stripe={stripe} customerId={props.customerId} />
      )}
    </ElementsConsumer>
  );
};

export default PaymentCards;
